import { Form, Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { textsTransport } from './constants/texts';
import useCreateTransport from './api/mutation/useCreateTransport';
import useChangeTransport from './api/mutation/useChangeTransport';
import FooterModal from '../FooterModal/FooterModal';
import FormTransport from './components/FormTransport/FormTransport';
import useGetTransportById from './api/query/useGetTransportById';
import { Provider, useSetTsAttachments, useTsAttachments } from './model';
import { checkExists } from '../../queries/useCheckExistQuery';

const confirm = Modal.confirm;

const TransportModalNode = ({ form, visible, values, onCancel, ...props }) => {
  const {
    id,
    clientId,
    addressId,
    onSuccess,
    companyId,
    addFromPermit = false,
    valueForTs = {},
  } = values || {};

  const [isFetchingCheckExist, setisFetchingCheckExist] = useState(false);

  const isEdit = !!id;

  const [transport, setTransport] = useState({});

  const { resetFiles } = useSetTsAttachments();
  const attachments = useTsAttachments();

  const {
    mutateAsync: onCreateTransport,
    isLoading: isFetchingCreateTransport,
  } = useCreateTransport(onSuccess);
  const {
    mutateAsync: onChangeTransport,
    isLoading: isFetchingChangeTransport,
  } = useChangeTransport(onSuccess);
  const { mutateAsync: getTransportById, isLoading: isLoadingTransport } =
    useGetTransportById();

  const isFetching =
    isFetchingCheckExist ||
    isFetchingCreateTransport ||
    isFetchingChangeTransport ||
    isLoadingTransport;

  const showConfirm = (transport) => {
    return new Promise((resolve) => {
      confirm({
        title:
          'Транспортное средство с таким номером есть в системе, но марка и модель отличаются от введенных',
        content: `Добавить клиенту с маркой ${transport?.brand} и моделью ${transport?.model}? Иначе обратитесь в техническую поддержку`,
        okText: 'Да',
        cancelText: 'Нет',
        zIndex: 20000,
        onOk: () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
        onClose: () => {
          resolve(false);
        },
      });
    });
  };

  const handleClose = () => {
    resetFiles();

    setTransport({});

    onCancel();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    form.validateFields(async (err, formValues) => {
      if (!err) {
        const {
          countryId,
          number,
          region,
          model,
          brand,
          clientId: clientIdForm,
          addressId: addressIdForm,
          transportTypeId,
        } = formValues;

        const upperNumber = number.toUpperCase();

        const values = {
          clientId: clientId || clientIdForm,
          addressId: addressId || addressIdForm,
          countryId,
          number: upperNumber,
          region,
          model,
          brand,
          transportTypeId,
        };

        if (isEdit) {
          await onChangeTransport({
            ...values,
            id,
          });
        } else {
          setisFetchingCheckExist(true);

          const checkData = await checkExists({
            number: upperNumber,
            region,
            countryId,
          });

          setisFetchingCheckExist(false);

          if (!checkData?.success) {
            await onCreateTransport({
              ...values,
              attachments: attachments || [],
            });
          } else {
            const transport = await getTransportById(checkData?.transportId);
            if (
              transport?.brand?.trim()?.toUpperCase() !==
                brand.trim()?.toUpperCase() ||
              transport?.model?.trim()?.toUpperCase() !==
                model.trim()?.toUpperCase()
            ) {
              const confirmed = await showConfirm(transport);
              if (!confirmed) return;

              await onCreateTransport({
                ...values,
                transportId: transport?.id,
                model: transport?.model,
                brand: transport?.brand,
                attachments: attachments || [],
              });
            } else {
              await onCreateTransport({
                ...values,
                transportId: transport?.id,
                attachments: attachments || [],
              });
            }
          }
        }

        handleClose();
      }
    });
  };

  useEffect(() => {
    (async () => {
      if (visible && !!id) {
        const ts = await getTransportById(id);

        setTransport(ts);
      }
    })();
  }, [!!id, visible]);

  return (
    <Modal
      visible={visible}
      width={900}
      zIndex={2000}
      destroyOnClose
      onCancel={handleClose}
      footer={
        <FooterModal
          onClose={handleClose}
          onOk={handleSubmit}
          isLoading={isFetching}
          disabled={isFetching}
        />
      }
      title={
        isEdit ? textsTransport.EDIT_TRANSPORT : textsTransport.CREATE_TRANSPORT
      }
      {...props}
    >
      <Spin spinning={isFetching}>
        <Form>
          <FormTransport
            form={form}
            companyId={companyId}
            isEdit={isEdit}
            transport={transport}
            addFromPermit={addFromPermit}
            valueForTs={valueForTs}
          />
        </Form>
      </Spin>
    </Modal>
  );
};

const TransportModal = Form.create('transport-form')(TransportModalNode);

const Wrapped = (props) => (
  <Provider>
    <TransportModal {...props} />
  </Provider>
);

export default Wrapped;
